import React, { useState, useEffect } from 'react';
import './admin.css';
import axios from 'axios';
import API_URL from "../api/api";

const Admin = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [images, setImages] = useState([]);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [availability, setAvailability] = useState('AVAILABLE'); 
    const [year, setYear] = useState(new Date().getFullYear());

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            setIsLoggedIn(true);
        }
    }, []);

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(`${API_URL}/api/auth/login`, {
                username,
                password
            });
            const { token } = response.data;
            localStorage.setItem('token', token);
            setIsLoggedIn(true);
        } catch (error) {
            setError('Check login or password');
        }
    };

    const handleLogout = () => {
        localStorage.removeItem('token');
        setIsLoggedIn(false);
        setUsername('');
        setPassword('');
    };

    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        setImages((prevImages) => {
            const combined = [...prevImages, ...selectedFiles];
            return combined.slice(0, 5);
        });
    };

    const handleRemoveImage = (indexToRemove) => {
        setImages((prevImages) => prevImages.filter((_, index) => index !== indexToRemove));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (images.length === 0) {
            setError('Choose at least one picture');
            return;
        }

        const formData = new FormData();
        formData.append('title', title);
        formData.append('description', description);
        formData.append('availability', availability); 
        formData.append('year', year);

        images.forEach((image) => {
            formData.append(`images`, image);
        });

        try {
            const token = localStorage.getItem('token');
            if (!token) {
                setError('Please log in');
                return;
            }

            setLoading(true); 

            await axios.post(`${API_URL}/api/upload`, formData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                }
            });

            setLoading(false); 
            setSuccess(true);  
            setTitle('');
            setDescription('');
            setImages([]);
            setAvailability('AVAILABLE');
            setYear(new Date().getFullYear());
        } catch (error) {
            setLoading(false); 
            setError('Hmmm... try again, it didnt end well 😅');
        }
    };

    return (
        <div className="admin">
            {!isLoggedIn ? (
                <div className="login-form">
                    <h2>Admin Panel</h2>
                    <form onSubmit={handleLogin}>
                        <div className='form-div'>
                            <label htmlFor="username">Login</label>
                            <input
                                type="text"
                                id="username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                required
                            />
                        </div>
                        <div className='form-div'>
                            <label htmlFor="password">Password</label>
                            <input
                                type="password"
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                        </div>
                        {error && <div className="error">{error}</div>}
                        <button className='button' type="submit">Enter</button>
                    </form>
                </div>
            ) : (
                <div className="image-upload-form">
                    <h2>Add Picture</h2>
                    <form onSubmit={handleSubmit}>
                        <div className='form-div'>
                            <label htmlFor="title">Name</label>
                            <input
                                type="text"
                                id="title"
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                                required
                            />
                        </div>
                        <div className='form-div'>
                            <label htmlFor="description">Description</label>
                            <textarea
                                id="description"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                required
                            />
                        </div>
                        
                        <div className='form-div'>
                            <label htmlFor="year">Year</label>
                            <select
                                id="year"
                                value={year}
                                onChange={(e) => setYear(e.target.value)}
                                required
                            >
                                {Array.from({ length: 12 }, (_, i) => 2024 + i).map(y => (
                                    <option key={y} value={y}>{y}</option>
                                ))}
                            </select>
                        </div>

                        <div className='form-div'>
                            <label htmlFor="availability">Status</label>
                            <select
                                id="availability"
                                value={availability}
                                onChange={(e) => setAvailability(e.target.value)}
                                required
                            >
                                <option value="AVAILABLE">AVAILABLE</option>
                                <option value="NOT_AVAILABLE">NOT AVAILABLE</option>
                            </select>
                        </div>

                        <div className='form-div'>
                            <label htmlFor="image">Picture</label>
                            <input
                                type="file"
                                id="image"
                                onChange={handleFileChange}
                                multiple
                            />
                            
                            {images.length > 0 && (
                                <div className="preview-container">
                                    {images.map((image, index) => (
                                        <div key={index} className="preview-wrapper">
                                            <img 
                                                src={URL.createObjectURL(image)} 
                                                alt={`preview-${index}`} 
                                                className="preview-image" 
                                            />
                                            <button 
                                                type="button" 
                                                className="preview-remove-btn" 
                                                onClick={() => handleRemoveImage(index)}
                                            >
                                                ×
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        <button className='button' type="submit" disabled={loading}>Upload Picture</button>
                        {loading && <div>Uploading...</div>}
                        {success && <div style={{ color: 'green' }}>Picture uploaded successfully!</div>}
                        {error && <div className="error">{error}</div>}
                        <button type="button" className="button logout-btn" onClick={handleLogout}>
                            Logout
                        </button>
                    </form>
                </div>
            )}
        </div>
    );
};

export default Admin;